import { render, staticRenderFns } from "./status-form-restrictions.vue?vue&type=template&id=5c0be8c9&scoped=true"
import script from "./status-form-restrictions.vue?vue&type=script&lang=js"
export * from "./status-form-restrictions.vue?vue&type=script&lang=js"
import style0 from "./status-form-restrictions.vue?vue&type=style&index=0&id=5c0be8c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0be8c9",
  null
  
)

export default component.exports